<template>
  <div class="search_container searchArea">
    <el-form
      :inline="true"
      :model="search_data"
      ref="search_data"
      class="demo-form-inline search-form"
    >
      <el-form-item label>
        <el-tag size="medium" effect="dark">成员:{{this.studentAndClassTypeSearch.stdName}}</el-tag>
      </el-form-item>
      <el-form-item class="btnRight">
        <el-button
          v-show="ROLE == 1"
          type="primary"
          size="mini"
          icon="view"
          @click="onAddClassHourSpend()"
        >添加</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getToken } from "@/utils/auth";

export default {
  name: "searchItem",
  data() {
    return {
      search_data: {
        stdName: ""
      },
      ROLE: 0
    };
  },
  computed: {
    ...mapGetters(['studentAndClassTypeSearch'])
  },
  created() {
    this.ROLE = getToken("ROLE");
  },
  methods: {
    onScreeoutMoney(searchForm) {
      this.$refs[searchForm].validate(valid => {
        if (valid) {
          this.$store.commit("SET_STUDENT_SEARCH", this.search_data);
          this.$emit("searchList");
        }
      });
    },
    onAddClassHourSpend() {
      this.$emit("showDialog", "add");
    }
  }
};
</script>

<style lang="less" scoped>
.search_container {
  margin-bottom: 20px;
}
.btnRight {
  float: right;
  margin-right: 0px !important;
}
.searchArea {
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  padding: 18px 18px 0;
}
</style>
